import React from 'react';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';

import moment from 'moment';

import HeaderMobile from 'components/HeaderMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { TravelContainer, TravelInfo, ArrowsContainer, DateInfo } from './styles';

interface InfoProps {
  departurePoint?: string;
  arrivalPoint?: string;
  departureDate?: Date;
  returnDate?: Date;
  isOneWay: boolean;
}

interface Props {
  info: InfoProps;
  loading: boolean;
  goBack: () => void;
  onEdit: () => void;
}

const FlightsListHeader = ({ info, loading, goBack, onEdit }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <>
      <HeaderMobile goBack={goBack} onClose={goBack} buttonLabel={t('flightsList.edit')}>
        <div>
          <TravelContainer>
            <TravelInfo>{info.departurePoint}</TravelInfo>
            <ArrowsContainer>
              <IoIosArrowRoundForward size={15} />
              {!info.isOneWay && <IoIosArrowRoundBack size={15} />}
            </ArrowsContainer>
            <TravelInfo>{info.arrivalPoint}</TravelInfo>
          </TravelContainer>
          <DateInfo>
            {moment(info.departureDate).format('ddd DD, MMM')}
            {`${info.returnDate ? ` - ${moment(info.returnDate).format('ddd DD, MMM')}` : ''}`}
          </DateInfo>
        </div>
      </HeaderMobile>
    </>
  );
};

export default FlightsListHeader;
